<template>
    <f7-page
        :page-content="false"
        :class="`home-scroll ${ variant === 0 ? '' : 'withHalfBgGReen'}`"
        name="Home"
        no-navbar
        navbar-hidden
        no-swipeback
    >
        <transition
            name="fade"
            appear
        >
            <div
                v-if="showOnboarding > 1"
                class="onboarding-bubble"
            >

                <template v-if="showOnboarding === 4">
                    <transition
                        name="fade"
                        appear
                    >
                        <div>
                            <p style="margin: 14px 4px">We've made it easier to achieve your goals, but don't worry, we saved your previous progress.</p>
                            <f7-button
                                small
                                color="red"
                                fill
                                round
                                style="max-width: 65%"
                                @click="onboardingBlockerClick()"
                            >Continue</f7-button>
                        </div>
                    </transition>
                </template>
                <template v-if="showOnboarding === 2">
                    <transition
                        name="fade"
                        appear
                    >
                        <div>
                            <h3>Welcome to Coral!</h3>
                            <p style="margin: 14px 4px">These are your goals.</p>
                            <f7-button
                                small
                                color="red"
                                fill
                                round
                                style="max-width: 65%"
                                @click="onboardingBlockerClick()"
                            >Continue</f7-button>
                        </div>
                    </transition>
                </template>
                <template v-if="showOnboarding === 3">
                    <transition
                        name="fade"
                        appear
                    >
                        <div>
                            <h3>Start here</h3>
                            <p style="margin: 14px 4px">What you need to know to crush your goals.</p>
                        </div>
                    </transition>
                </template>

            </div>
        </transition>
        <div
            v-if="showOnboarding"
            class="onboarding-blocker"
            @click="onboardingBlockerClick"
        />
        <transition name="from-top">
            <div
                v-if="showOnboarding"
                class="onboarding-shader-top"
            />
        </transition>
        <transition name="from-top">
            <div
                v-if="showOnboarding"
                class="onboarding-shader-bottom"
            />
        </transition>
        <transition name="from-side">
            <div
                v-if="showOnboarding === 3"
                class="onboarding-shader-right"
            />
        </transition>
        <transition name="from-side">
            <div
                v-if="showOnboarding === 3"
                class="onboarding-shader-left"
            />
        </transition>

        <f7-page-content>
            <p
                v-if="(user.isAdmin || !user.isSubscribed)"
                style="position: absolute; top: 22px; right: 16px; z-index: 20"
            >
                <f7-button
                    :href="user.isAdmin ? '/admin' : (user.isSubscribed ? '#' : '/subscribeStart')"
                    :color="!user.isSubscribed ? 'red' : 'gray'"
                    fill
                    small
                    round
                >{{ user.isAdmin ? 'ADMIN' : 'UPGRADE' }}</f7-button>
            </p>
            <f7-block style="position: relative; height: 110px; z-index: 10">

                <svg
                    id="logoSvg"
                    width="120px"
                    viewBox="0 0 432 162"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                    <path
                        :fill="darkTheme ? 'white' : 'black'"
                        d="M125.07,55.31c-1.45,3.77-2.36,6.07-3.19,6-.33,0-1-.69-1.11-1.53-6-19.45-22.11-25.6-39-26.14-30.19-1-48,20.25-48.89,49.77-.91,28.87,14.24,53.76,45.43,54.74,22.06.7,36.48-9,42.66-20.41.77-1,1.93-3.12,2.83-4.69a1.19,1.19,0,0,1,2.12.12c1.5,3.45,4.5,9.33,5.65,11.57a1.2,1.2,0,0,1-.35,1.51l-4.48,3.3c-13.91,9.36-31,13.3-47.73,12.77-32.18-1-65.09-21.14-64-57C16.2,48.06,47.7,28.46,82,29.54c17.76.56,33.28,5.86,45.8,15.7a1.23,1.23,0,0,1,.38,1.37Z"
                    />
                    <path
                        :fill="darkTheme ? 'white' : 'black'"
                        d="M180.77,51.13c25.07,0,49.13,18.25,49.13,45.64s-24.06,45.64-49.13,45.64-49.12-18.26-49.12-45.64S155.71,51.13,180.77,51.13Zm0,87.13c24.57,0,33.37-18.92,33.2-41.49.17-22.57-8.63-41.5-33.2-41.5s-33.36,18.93-33.19,41.5C147.41,119.34,156.21,138.26,180.77,138.26Z"
                    />
                    <path
                        :fill="darkTheme ? 'white' : 'black'"
                        d="M279.74,67.72c-2-1.66-4.48-4.31-9-4.31-13.94,0-18.42,16.76-18.42,43v10.13c0,12.28,1.49,20.08,8.13,20.91,1.82.17,2.82.83,2.82,2,0,.83-.5.83-1.33.83-2.82,0-9-.33-14.77-.33s-12,.33-14.77.33c-.83,0-2-.33-2-.83,0-.66,1.16-1.49,2.82-2.15,5.31-2.66,6.8-8.47,6.8-23.74V65.4c0-3.32-2.82-5.48-5.64-6.47-1.33-.34-2.49-1-2.49-1.33s1-.67,2.16-1L251.36,52V75.19h.33c7.47-16.26,17.26-24.06,33.69-24.06Z"
                    />
                    <path
                        :fill="darkTheme ? 'white' : 'black'"
                        d="M370.69,115c0,10.46,1.33,21.25,5.81,22.74.83.34,1.33.83,1.33,1.33a1.35,1.35,0,0,1-1.5,1.16c-.66,0-4.65-.33-6.47-.33-2.16,0-4.32.33-6.14.33-1.33,0-2-.83-2-1.32,0-4.15-2.33-11-2.82-15.61h-.34c-7.13,14.28-19.75,19.09-35,19.09-16.1,0-35.35-8.46-35.35-26.56,0-25.39,37.84-29.21,56.6-29.21h12.61c0-19.42-5.48-31.37-26.56-31.37-11.61,0-30.37,6.31-31.86,19.42,0,.5-.33.67-.83.67-.33,0-.5,0-.67-.5L293,59.09a96.52,96.52,0,0,1,37.35-8c30.2,0,40.33,13.11,40.33,32.36ZM345.13,90.79c-17.59,0-41,3.32-41,25.4,0,14.6,11.29,22.07,24.73,22.07,24.9,0,28.55-19.92,28.55-40.16V90.79Z"
                    />
                    <path
                        :fill="darkTheme ? 'white' : 'black'"
                        d="M407.38,115.85c0,9.63.83,19.42,6.14,21.58,1.66.67,3.49,1.33,3.49,2.16,0,.5-2,.66-2.82.66-2,0-8.14-.33-12.95-.33s-10.95.33-13.77.33c-3,0-3.66-.16-3.66-.66,0-.83,2.16-1.49,4.49-2.49,6-2.66,6.8-17.1,6.8-34.36V43.82c0-12.45-1.33-16.1-5.81-17.76-1.16-.33-1.66-.66-1.66-1,0-.5.83-.83,1.5-1l18.25-4.48Z"
                    />

                </svg>

                <transition
                    name="slide-fade-sun"
                    appear
                >
                    <img
                        src="../img/1.2.0/sun.png"
                        style="width: 140px; position: absolute; top: 70px; left: 50%; margin-left: -70px"
                    >
                </transition>
                <img
                    src="../img/1.4.0/homeRight1.png"
                    style="width: 240px; position: absolute; top: 40px; right: 0px; z-index: -10"
                >

            </f7-block>
            <f7-block
                v-if="course && topicsIndex[course.topicId]"
                :style="`z-index: 11; background-color: ${variant === 0 ? topicsIndex[course.topicId].color : '#0A3020'}; ${variant === 1 ? 'min-height: 353px;': ''}`"
                class="homeBlockWrapper"
            >
                <!-- this is the hill -->
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1231.5px"
                    height="75px"
                    viewBox="0 0 2453 149"
                    style="width: 1231.5px; position: absolute; top: -72px; left: -20px; z-index: 12"
                >
                    <g>
                        <path
                            :fill="variant === 0 ? topicsIndex[course.topicId].color : '#0A3020'"
                            d="M9.77.07S67.7,12.28,95.19,42.83s42.76,70.25,82.47,85.52,106.91,6.11,149.67,33.6,58,85.53,113,106.91,73.31-6.11,155.78,36.66S645.07,385,736.63,421.59c152,60.73,305.71-41.71,520.18-6.11V2041.7H0S23.17-13.33,9.77.07Z"
                        />
                        <path
                            :fill="variant === 0 ? topicsIndex[course.topicId].color : '#0A3020'"
                            d="M506.114524,143.801238 C564.063532,146.205155 582.931801,112.692317 646.336694,93.0045385 C686.860476,80.4372241 674.426594,100.226433 819.561036,84.5451841 C858.740615,80.3155068 908.229048,93.0045385 928.846758,71.8460092 C949.464467,50.68748 982.46664,57.0370674 1003.08435,57.0370674 C1023.70206,57.0370674 1060.8258,37.9883052 1081.44351,35.868395 C1102.06122,33.7484848 1149.49381,10.5106178 1219.60984,2.01069091 C1289.72586,-6.489236 1333.02701,14.7098657 1333.02701,14.7098657 C1356.81644,40.3520486 1388.65493,60.1478527 1428.54249,74.0972782 C1482.60668,93.0045385 1590.90439,111.000488 1669.17291,122.708768 C1678.94529,124.170629 1855.48677,83.0930211 1921.35084,84.5451841 C1981.5991,85.8735301 2031.40338,29.8164373 2096.5642,35.868395 C2137.09188,39.6324943 2183.52777,74.8888282 2222.45437,84.5451841 C2267.60297,95.7450021 2346.64199,94.8288191 2381.94753,103.593946 C2445.28283,119.317885 2450.49515,141.351924 2454,143.801238 C2462.34004,149.62956 1542.85503,145.361207 1514.46994,146.367445 C1490.67818,147.210852 1430.52666,147.210852 1334.01539,146.367445 L106.589569,146.367445 C70.7592494,146.157979 47.0378702,146.157979 35.4254309,146.367445 C14.2351313,146.749677 1.14735601,150.280222 0.982527816,146.367445 C0.689522371,138.347268 35.0286798,115.623319 104,78.1955966 C104,78.1955966 114.308855,71.8460092 159.675723,59.1468344 C205.042591,46.4476596 266.905604,78.1955966 289.589038,93.0045385 C325.170895,116.222119 338.395486,92.771247 380.322774,103.593946 C403.172996,109.496342 425.308617,118.001754 446.317236,128.951723 C465.146351,137.764181 485.442512,142.804344 506.114524,143.801238 Z"
                        />
                    </g>
                </svg>
                <img
                    src="../img/1.4.0/homeLeft1.png"
                    style="width: 180px; position: absolute; top: -143px; left: -10px; z-index: 13"
                >
                <img
                    src="../img/1.4.0/homeRight3.png"
                    style="width: 100px; position: absolute; top: -140px; right: 0px; z-index: 14"
                >
                <goals :variant="variant" />
                <template v-if="home.dailyCoral && home.dailyCoral.length && home.dailyCoral[0] && (course.id !== FEELING_PRESENT_IN_YOUR_BODY || [1,3].indexOf(variant) > -1)">
                    <daily :daily-coral="home.dailyCoral[0]" />
                </template>
            </f7-block>
            <template v-if="course && topicsIndex[course.topicId] && [0,2, 3].indexOf(variant) > -1">
                <resume
                    :course="course"
                    :key="course.id"
                    :variant="variant"
                />
            </template>

            <!-- <next-up
                :course-id="user.currentCourseId"
                :key="`nextup-home-${user.currentCourseId}-${loaded}`"
            /> -->
            <template v-if="(onboardingCompleted > 1 && [1,3].indexOf(variant) > -1) || (course.id !== FEELING_PRESENT_IN_YOUR_BODY && variant === 2) && home.dailyPoll.length">
                <poll :attachment="home.dailyPoll[0]" />
            </template>

            <template v-if=" (onboardingCompleted > 1 && [1,3].indexOf(variant) > -1) || (course.id !== FEELING_PRESENT_IN_YOUR_BODY && variant === 2) && home.dailyPoll.length">
                <playlists />
            </template>

            <template v-if="onboardingCompleted === 1 && variant === 0">
                <f7-block class="center">
                    Complete "This will change your life" to<br>unlock the rest of the app
                </f7-block>
            </template>
            <br><br><br><br>
        </f7-page-content>
        <app-tabbar
            v-if="onboardingCompleted > 1"
            tab="home"
        />
    </f7-page>
</template>

<script>
import AppTabbar from '../components/appTabbar.vue';

import NextUp from '../components/nextUp.vue';
import Resume from '../components/home/resume.vue';
import Daily from '../components/home/daily.vue';
import Goals from '../components/home/goals.vue';
import Poll from '../components/home/poll.vue';
import Playlists from '../components/home/playlists.vue';

import utils from '../js/utils';
import {
    BEGIN_THE_REVOLUTION,
    CHANGE_YOUR_LIFE_IDS,
    FEELING_PRESENT_IN_YOUR_BODY,
    CORAL_BRANDING
} from '../js/constants';

export default {
    store: [
        'api',
        'user',
        'topics',
        'topicsIndex',
        'myTopics',
        'unitsIndex',
        'fullDataIndex',
        'progress',
        'currentCourse',
        'courses',
        'coursesIndex',
        'myTraits',
        'nextMajor', // for bg color only
        'onboardingCompleted',
        'trackerData',
        'home',
        'darkTheme'
    ],
    components: {
        AppTabbar,
        NextUp,
        Poll,
        Daily,
        Resume,
        Goals,
        Playlists,
    },
    data () {
        return {
            variant: 0,
            startingCourseId: FEELING_PRESENT_IN_YOUR_BODY,
            loaded: 0,
            isLoading: true,
            showOnboarding: 0,
            course: {
                id: 0,
                name: '',
                description: '',
                data: {},
                topicId: 0,
                packs: [],
                units: []
            },
            infinite: false,
            FEELING_PRESENT_IN_YOUR_BODY,
        };
    },
    computed: {
        isPgap: function () {
            return pgap;
        }
    },
    watch: {
        'user.currentCourseId': function () {
            this.getHomeCourse();
        },
        onboardingCompleted: function () {
            if (this.onboardingCompleted > 1) {
                this.showOnboarding = 0;
            }
        }
    },
    created: function () {
        this.variant = parseFloat(window.localStore.getItem(`experiment-014_goals`));

        f7.params.panel.leftBreakpoint = 768;
        this.initBreakpoints();

        this.$events.on('get-home', () => {
            this.isLoading = false;
            this.getHomeCourse();
            this.getHome();
        });
        setTimeout(() => {
            if (this.user.sessions >= 1 &&
                (!window.localStore.getItem('notifications-push') ||
                    !window.localStore.getItem('notifications'))
            ) {
                this.$events.fire('notifications-push');
            }
            if (this.user.sessions >= 3 && !window.localStore.getItem('notifications-sms') && this.user.phone) {
                this.$events.fire('notifications-sms');
            }
            if (this.user.sessions > 4) {
                this.$events.fire('ask-for-rating');
            }
            this.$events.fire('pulse-get');
            if (pgap && !window.localStore.getItem('darkModeAsked')) this.goDarkMode();
        }, 420);
        if (this.user.currentCourseId === 0) this.user.currentCourseId = this.startingCourseId;
        // failsafe force onboarding if gender is not set
        // 3 secs was too short
        setTimeout(() => {
            // 999999 checks traits are loaded from server, see store.js
            if (this.myTraits.length < 4 && this.myTraits[0] !== 999999) {
                f7.views['main'].router.navigate('/onboarding');
            }
        }, 3000);
        this.isLoading = false;
        this.getHomeCourse();
        this.getHome();

        if (utils.isMobile() && !pgap && !window.localStore.getItem('promptedToGetApp')) {
            window.localStore.setItem('promptedToGetApp', true);
            f7.views['main'].router.navigate('/betteronmobile');
        }
        if (this.$f7route.query.onboarding) {
            // this.showOnboarding = 0;
            // For debug of animation
            // this.onboardingCompleted = 1;
        }

        if ([1, 3].indexOf(this.variant) > -1 && this.onboardingCompleted < 2) {
            setTimeout(() => {
                if (this.myTopics.length === 0) {
                    return f7.views['main'].router.navigate('/onboarding/goals');
                }
                this.showOnboarding = 1;
                $$('.home-scroll .page-content').scrollTop(0, 400);
            }, 1000);
            setTimeout(() => {
                this.showOnboarding = 2;
                $$('.home-scroll .page-content').scrollTop(0, 400);
            }, 2500);
        }
    },
    beforeDestroy: function () {
        this.$events.off('get-home');
    },
    methods: {
        initBreakpoints: function () {
            let panel = f7.panel.get('.panel-left');
            panel.params.visibleBreakpoint = 768;
            panel.enableVisibleBreakpoint();
        },
        goDarkMode: function () {
            if (this.user.sessions > 1 && cordova.plugins && cordova.plugins.ThemeDetection) {
                cordova.plugins.ThemeDetection.isDarkModeEnabled(
                    (success) => {
                        if (success.value && !this.darkTheme) {
                            window.localStore.setItem('darkModeAsked', true);
                            f7.dialog.confirm('Your device runs on Dark Mode. Would you like to enable Coral\'s Dark Mode? This can be changed in settings', () => {
                                this.darkTheme = true;
                                window.localStore.setItem('darkTheme', 1);
                            });
                        }
                    },
                    (error) => {
                        console.log(error);
                    }
                );
            }
        },
        goTo: function (url) {
            f7.views['main'].router.navigate(url);
        },
        onboardingBlockerClick: function () {
            if (this.showOnboarding === 3) {
                this.goTo(`/courses/${FEELING_PRESENT_IN_YOUR_BODY}`)
            } else if (this.showOnboarding === 2) {
                this.showOnboarding++
            } else if (this.showOnboarding === 4) {
                this.showOnboarding = 0;
            }
        },
        getHome: function () {
            this.$http.get(`${this.api}/home`).then(response => {
                let data = response.body;
                if (data.dailyPoll && data.dailyPoll[0]) {
                    let lastPoll = parseFloat(window.localStore.getItem('last-poll'));
                    if (lastPoll !== data.dailyPoll[0].id || !this.home.dailyPoll[0]) {
                        for (let i = 0; i < data.dailyPoll[0].data.answers.length; i++) {
                            const answer = data.dailyPoll[0].data.answers[i];
                            answer.width = 0;
                            answer.percentage = 0;
                            answer.answerPc = '';
                        }
                        this.home.dailyPoll = data.dailyPoll;
                    }
                }
                this.home.dailyCoral.length = 0;
                this.home.dailyCoral.push(data.dailyCoral[0]);
            }, () => {
                console.error('Could not get home')
            });
        },
        getHomeCourse: function () {
            // CHANGE to currentcourse
            if (this.user.currentCourseId !== 0 && this.user.currentCourseId !== CORAL_BRANDING && this.user.currentCourseId !== FEELING_PRESENT_IN_YOUR_BODY && this.onboardingCompleted !== 2) {
                console.log('Set onboardingCompleted because of currentCourseId')
                this.onboardingCompleted = 2;
                window.localStore.setItem('onboardingCompleted', 2);
            } else if (this.onboardingCompleted !== 2) {
                if (this.unitsIndex[BEGIN_THE_REVOLUTION] && this.unitsIndex[BEGIN_THE_REVOLUTION].completed) {
                    this.onboardingCompleted = 1;
                    window.localStore.setItem('onboardingCompleted', 1);
                }
                for (let i = 0; i < CHANGE_YOUR_LIFE_IDS.length; i++) {
                    if (this.unitsIndex[CHANGE_YOUR_LIFE_IDS[i]] && this.unitsIndex[CHANGE_YOUR_LIFE_IDS[i]].completed) {
                        this.onboardingCompleted = 2;
                        window.localStore.setItem('onboardingCompleted', 2);
                        break;
                    }
                }
            }
            if (this.onboardingCompleted > 0) {
                $$('.home-scroll .page-content').scrollTop(0, 400);
            }
            this.showHidden = false;
            if (this.coursesIndex[this.user.currentCourseId]) {
                this.course = this.coursesIndex[this.user.currentCourseId];
            } else {
                // recover from hidden unpublished course
                this.user.currentCourseId = this.startingCourseId;
                this.course = this.coursesIndex[this.user.currentCourseId];
            }
        },
    }
};
</script>
<style lang="less" scoped>
@import '../css/colors.less';
.center {
    text-align: center;
}
h2 {
    color: white;
    position: relative;
    z-index: 15;
    text-align: left;
    font-family: Editor-Bold;
    font-size: 21px;
    line-height: 26px;
    margin: 0 0 8px;
}
.blockTitle {
    margin-left: 0;
    color: white;
    font-family: AndesMedium;
    font-style: normal;
    font-weight: 300;
    font-size: 15px;
    line-height: 15px;
    z-index: 15;
    position: relative;
    margin-bottom: 4px;
}
.courseDescription {
    margin-top: -4px;
    color: white;
    font-family: AndesLight;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 14px;
    padding-bottom: 12px;
    z-index: 15;
    position: relative;
}
.moreLink {
    font-family: AndesMedium;
    text-transform: uppercase;
    line-height: 44px;
    color: #d9ccc4;
}
.nextLink {
    color: white;
    font-family: AndesMedium;
    text-transform: uppercase;
    line-height: 64px;
    z-index: 15px;
    position: relative;
    z-index: 16;
}
.home-scroll {
    margin-top: -100px !important;
    padding-top: 100px !important;
    height: ~'calc(100% + 100px)' !important;
    max-height: ~'calc(100% + 200px)' !important;
}
.homeBlockWrapper {
    text-align: left;
    transition: background-color 1s;
    color: white;
    background-size: 100% auto;
    background-position: bottom left;
    background-repeat: no-repeat;
    margin-bottom: 0px;
    padding-bottom: 20px;
}
.homeBlock {
    max-width: 100vw;
    background: white;
    padding: 0px;
    margin: 0px 0px 0px;
    border-radius: 13px;
    z-index: 15;
    position: relative;
}
.theme-dark .homeBlock {
    background: @black;
}
.resetButton {
    z-index: 9999;
    // position: absolute;
    bottom: 64px;
    background: #ddd;
    color: white;
    border-radius: 20px;
    padding: 4px 20px;
    display: inline-block;
    text-align: center;
}
.ios.device-iphone-x .resetButton {
    bottom: 100px;
}

.onboarding-shader-top {
    background: rgba(169, 169, 169, 0.7);
    // backdrop-filter: blur(10px);
    // -webkit-backdrop-filter: blur(10px);
    position: absolute;
    top: 100px;
    left: 0px;
    height: ~'calc(190px + env(safe-area-inset-top))';
    width: 100%;
    z-index: 99999;
}
.onboarding-shader-bottom {
    background: rgba(169, 169, 169, 0.7);
    // backdrop-filter: blur(10px);
    // -webkit-backdrop-filter: blur(10px);
    position: absolute;
    bottom: 0px;
    left: 0px;
    height: ~'calc(100% - 480px - env(safe-area-inset-top))';
    width: 100%;
    z-index: 99999;
}
.from-top-enter-active,
.from-top-leave-active {
    transition: all 1s;
}
.from-top-enter, .from-top-leave-to /* .fade-leave-active below version 2.1.8 */ {
    height: 0px;
}
.onboarding-shader-right {
    background: rgba(169, 169, 169, 0.7);
    // backdrop-filter: blur(10px);
    // -webkit-backdrop-filter: blur(10px);
    position: absolute;
    top: ~'calc(290px + env(safe-area-inset-top))';
    left: 0px;
    height: 190px;
    width: 12px;
    z-index: 99999;
}
.onboarding-shader-left {
    background: rgba(169, 169, 169, 0.7);
    // backdrop-filter: blur(10px);
    // -webkit-backdrop-filter: blur(10px);
    position: absolute;
    top: ~'calc(290px + env(safe-area-inset-top))';
    right: 0px;
    height: 190px;
    width: ~'calc(100% - 140px)';
    z-index: 99999;
}

.from-side-enter-active,
.from-side-leave-active {
    transition: all 1s;
}
.from-side-enter, .from-side-leave-to /* .fade-leave-active below version 2.1.8 */ {
    width: 0px;
}

.onboarding-bubble {
    position: absolute;
    width: 260px;
    height: 126px;
    border-radius: 16px;
    left: 40px;
    top: ~'calc(140px + env(safe-area-inset-top))';
    background: white;
    z-index: 999990;
    text-align: center;
    h3 {
        font-family: Editor-Bold;
        font-style: normal;
        font-size: 17px;
        margin: 16px 0 0px;
    }
    p {
        padding: 0 20px;
        font-family: AndesBook;
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 20px;
    }
}
.theme-dark .onboarding-bubble {
    color: black;
}
.onboarding-bubble::after {
    content: '';
    border: 12px solid transparent;
    border-top-color: white;
    border-bottom: 0;

    /* [THESE WILL POSITION THE TRIANGLE] */
    position: absolute;
    bottom: -12px;
    left: 40px;
    margin-left: -12px;
}
.onboarding-blocker {
    background: red;
    opacity: 0;
    z-index: 22;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
}
</style>
